module.exports = __webpack_public_path__ + "img/small_animals_all.6bc75abc.jpg";